<script>
import transparenciaServico from '../../../servico';
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import CabecalhoRelatorio from '../CabecalhoRelatorio.vue';
import { datepicker } from 'vue-strap';


export default {
    components: { CabecalhoRelatorio, datepicker },
    data() {
        return {
            filtroPagamento: '',
            pagamentos: [],
            carregando: false,
            total: 0,
            tipoFiltro: [{ id: 1, text: 'CPF' }, { id: 2, text: 'CNPJ' }, { id: 3, text: 'Nome' }],
            idTipoFiltro: '3',
            habilitaFiltroCpf: false,
            habilitaFiltroCnpj: false,
            habilitaFiltragem: false,
            configuracao: this.$storage.configuracao(),
            dataInicio: '',
            dataFim: '',
        }
    },
    methods: {
        exportarExcel() {
            const data = [
                ["Relatório de Verificação de Pagamento"],
                [],
                ["Data: ", this.$options.filters.formatarData(new Date())],
                [],
                [`Total: ${this.pagamentos.length} registro(s)`],
                [],
                ["Projeto", "Data", "Dados do pagamento", "CPF/CNPJ", "Valor líquido (R$)"],
                [],
            ];

            this.pagamentos.forEach(item => {
                data.push([
                    item.nomeProjeto || '---',
                    this.$options.filters.formatarData(item.data),
                    (item.historico + " - " + item.formaPagamento + " - " + item.complemento) || '---',
                    item.cpfcnpj || '---',
                    this.$options.filters.formatarNumero(item.valor),
                ]);
            });

            data.push([])
            data.push(["", "", "", "Total: ", this.$options.filters.formatarNumero(this.total)]);

            const ws = XLSX.utils.aoa_to_sheet(data);

            const nomeArquivo = "verificacao_pagamento";

            const wb = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(wb, ws, nomeArquivo);

            const wbout = XLSX.write(wb, { bookType: "xlsx", type: "array" });
            saveAs(new Blob([wbout], { type: "application/octet-stream" }), `${nomeArquivo}.xlsx`);

        },
        imprimirPagina() {
            window.print();
        },
        async lista() {
            try {
                this.carregando = true;
                await transparenciaServico
                    .institucionalPagamentos(this.filtroPagamento, this.idTipoFiltro, this.dataInicio, this.dataFim)
                    .then(institucionalPagamentos => {
                        this.pagamentos = institucionalPagamentos;
                    });

                this.total = this.getTotal()
            } catch (error) {
                this.pagamentos = []
                if(error.body.mensagem){
                    this.$swal('', error.body.mensagem , 'error');
                }else{
                    this.$swal('', 'Ocorreu um erro ao carregar os dados, tente novamente.', 'error');
                }
            } finally {
                this.carregando = false;
            }
        },
        getTotal() {
            let total = 0;
            this.pagamentos.forEach(item => {
                total += item.valor;
            });
            return total;
        },
        placeholderFiltro() {
            switch (this.idTipoFiltro) {
                case 1:
                    return 'Digite o CPF';
                case 2:
                    return 'Digite o CNPJ';
                default:
                    return 'Digite o nome';
            }
        },
        aplicarMascara(event) {
            let valor = event.target.value;

            if (this.idTipoFiltro === 1) {
                valor = valor.replace(/\D/g, '');
                valor = valor.slice(0, 11);
                valor = valor
                    .replace(/(\d{3})(\d)/, '$1.$2')
                    .replace(/(\d{3})(\d)/, '$1.$2')
                    .replace(/(\d{3})(\d{1,2})$/, '$1-$2');

            } else if (this.idTipoFiltro === 2) {
                valor = valor.replace(/\D/g, '');
                valor = valor.slice(0, 14);
                valor = valor
                    .replace(/^(\d{2})(\d)/, '$1.$2')
                    .replace(/^(\d{2})\.(\d{3})(\d)/, '$1.$2.$3')
                    .replace(/\.(\d{3})(\d)/, '.$1/$2')
                    .replace(/(\d{4})(\d)/, '$1-$2');

            }
            this.filtroPagamento = valor;
        },
        desabilitaFiltragem(value){
            switch (this.idTipoFiltro) {
                case 1:
                    this.habilitaFiltroCnpj = true;
                    this.habilitaFiltroCpf = value.length == 14;
                    break
                case 2:
                    this.habilitaFiltroCnpj = value.length == 18;
                    this.habilitaFiltroCpf = true;
                    break
                default:
                    this.habilitaFiltroCnpj = true;
                    this.habilitaFiltroCpf = true;
            }
            this.habilitaFiltragem =  !this.carregando && this.filtroPagamento.length >= 3 && this.habilitaFiltroCpf &&  this.habilitaFiltroCnpj
      },
      voltar() {
          this.$router.push({
            name: 'transparencia.institucional',
            query: this.$route.query
          });
      },
      limparFiltros(){
          this.filtroPagamento = '';
          this.dataInicio = '';
          this.dataFim = '';
          this.idTipoFiltro = '3';
          this.habilitaFiltragem = false;          
      }
    },
    computed: {
      mostrarBotaoVoltar() {
        const mostrar = this.$route.name === 'transparencia.institucional.verificar.pagamento';
        return mostrar;
      },
      mostrarTitulo() {
        if (this.$route.name === 'transparencia.institucional.verificar.pagamento') {
          return 'Institucional - Verificação de Pagamento'
        }
        return 'Verificação de Pagamento';
      },
    },
    mounted() {
      if (!this.configuracao.acessarInstitucionalPortalTransparencia && !this.configuracao.mostrarVerificacaoPagamentoPortalTransparencia) {
        if (this.$route.name === 'transparencia.institucional.verificar.pagamento') {
          this.$router.push({
            name: 'transparencia.institucional',
            query: this.$route.query
          });
        } else {
          this.$router.push({
            name: 'transparencia.projetos',
            query: this.$route.query
          });        }
      }
    },
    watch: {
        idTipoFiltro(newValue) {
            this.filtroPagamento = '';
            this.placeholderFiltro();
            
        },
        filtroPagamento(newValue) {
            this.desabilitaFiltragem(newValue)
        }
    }
}
</script>

<template>
  <div>
    <div class="ibox float-e-margins">
      <div class="ibox-title hidden-print">
        <div class="row">
          <div class="col-md-10 flex-container" style="justify-content:start; padding-left:15px">
            <h3><b>{{ mostrarTitulo }}</b></h3>
          </div>

          <div class="col-md-2 flex-container" style="justify-content:end; gap:10px">

            <button class="btn btn-primary" @click="exportarExcel">
              <i class="fa fa-file-excel-o"></i> Excel
            </button>

            <button class="btn btn-primary" @click="imprimirPagina">
              <i class="fa fa-file-pdf-o"></i> PDF
            </button>

            <button class="btn btn-primary" @click="voltar" v-if="mostrarBotaoVoltar">
              <i class="fa fa-arrow-left"></i> Voltar
            </button>
          </div>
        </div>
      </div>

      <div class="ibox-content">

        <div class="row hidden-print">

          <div class="col-lg-6" :class="{'has-error': errors.has('filtroPagamento')}">
            <label class="control-label">Filtrar por *:</label>
          </div>

          <div class="col-lg-6">
            <label class="control-label">Periodo de pagamento</label>
          </div>

          <div class="col-lg-2 form-group">
            <select id="tipo-filtro" class="form-control" v-model="idTipoFiltro">
              <option :value="filtro.id" v-for="(filtro, index) in tipoFiltro">
                {{ filtro.text }}
              </option>
            </select>
          </div>

          <div class="col-lg-4 form-group required" style="margin-bottom: 0;"
            :class="{ 'has-error': errors.has('filtroPagamento') }">
            <input type="text" class="form-control" id="filtro-pagamento" v-model="filtroPagamento"
              data-vv-name="filtroPagamento" :placeholder="placeholderFiltro()" @input="aplicarMascara"
              data-vv-as="de filtro" v-validate="'required'" />
            <p class="text-danger" style="margin: 0; padding: 0;" v-show="errors.has('filtroPagamento')">{{
              errors.first('filtroPagamento') }}</p>
          </div>

          <div class="col-lg-3  control-label">
            <div class="row align-items-center" style="display: flex;">
              <div class="col-lg-1 control-label d-flex align-items-center" style="display: flex; align-items: center;">
                <label style="margin-bottom: 0;">De:</label>
              </div>
              <div class="col-lg-11 control-label">
                <datepicker v-model="dataInicio" format="dd/MM/yyyy" placeholder="  /  /     " lang="pt-BR"
                  data-vv-name="dataInicio" data-vv-as="data inicio" v-validate="'date_format:dd/MM/yyyy'"></datepicker>
              </div>
            </div>
          </div>


          <div class="col-lg-3 control-label">
            <div class="row align-items-center" style="display: flex;">
              <div class="col-lg-1 control-label d-flex align-items-center" style="display: flex; align-items: center;">
                <label style="margin-bottom: 0;">Até:</label>
              </div>
              <div class="col-lg-11 control-label">
                <datepicker v-model="dataFim" format="dd/MM/yyyy" placeholder="  /  /     " lang="pt-BR"
                  data-vv-name="dataFim" data-vv-as="data fim" v-validate="'date_format:dd/MM/yyyy'"></datepicker>
              </div>
            </div>
          </div>

        </div>

        <div class="row hidden-print">
          <div class="col-lg-12">

            <button class="btn btn-primary" type="button" style="margin-right: 5px;" @click="lista()"
              :disabled="!habilitaFiltragem">
              <i class="fa fa-search"></i> Filtrar
            </button>

            <button class="btn btn-primary" @click="limparFiltros"
              :disabled="!dataInicio && !dataFim && !filtroPagamento">
              Limpar Filtros
            </button>

          </div>
        </div>

        <cabecalho-relatorio titulo="Institucional" nomeProjeto="Relatório de verificação de pagamento"
          borda=""></cabecalho-relatorio>

        <div class="padding-5"></div>

        <div class="row text-right padding-20" v-if="!carregando">
          Total: {{ this.pagamentos.length }} registro(s)
        </div>

        <div class="table-responsive">

          <table class="table table-bordered table-hover table-striped pointer relatorio">
            <thead>
              <tr>
                <th>Projeto</th>
                <th>Data</th>
                <th>Dados do pagamento</th>
                <th>CPF/CNPJ</th>
                <th class="text-right">Valor líquido&nbsp;(R$)</th>
              </tr>
            </thead>
            <tbody>
              <tr v-if="pagamentos.length > 0 && !carregando" v-for="pagamento in pagamentos">
                <td>{{ pagamento.nomeProjeto }}</td>
                <td>{{ pagamento.data | formatarData('---') }}</td>
                <td>
                  {{ pagamento.historico }} <br /> {{ pagamento.formaPagamento + " - " + pagamento.complemento }}
                </td>
                <td>{{ pagamento.cpfcnpj || '---' }}</td>
                <td class="text-right">{{ pagamento.valor | formatarNumero }}</td>
              </tr>

              <tr v-if="!carregando && pagamentos.length > 0">
                <td colspan="4" class="text-right">
                  <span>{{ "Total:" }}</span>
                </td>
                <td colspan="1" class="text-right" style="font-weight: bold;">
                  <span>{{ total | formatarNumero }}</span>
                </td>
              </tr>

              <tr v-show="carregando">
                <td colspan="5" class="text-center">
                  <i class='fa fa-spinner fa-pulse'></i> Carregando...
                </td>
              </tr>

              <tr v-if="!carregando && pagamentos.length === 0">
                <td colspan="5" class="text-center">Não há dados.</td>
              </tr>
            </tbody>
          </table>

        </div>
      </div>
    </div>
  </div>
</template>



// WEBPACK FOOTER //
// FrontEnd/modulos/transparencia/componentes/compartilhado/institucional/InstitucionalVerificarPagamento.vue